import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-shell tw-overflow-auto tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50" }
const _hoisted_2 = { class: "tw-w-full tw-border-collapse tw-text-left tw-text-sm tw-text-slate-800" }
const _hoisted_3 = { class: "table-head" }
const _hoisted_4 = {
  key: 0,
  class: "tw-whitespace-nowrap tw-px-2 tw-pr-0 -tw-mr-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer tw-relative"
}
const _hoisted_5 = ["checked"]
const _hoisted_6 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-ml-3" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  scope: "col",
  class: "tw-w-14 tw-px-2 tw-py-3 tw-text-center tw-font-semibold tw-text-slate-700",
  "aria-label": "Notes"
}
const _hoisted_10 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_11 = ["checked"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_14 = ["checked"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_17 = ["checked"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_20 = ["checked"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_23 = ["checked"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_26 = ["checked"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_29 = ["checked"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }
const _hoisted_32 = ["checked"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_35 = ["checked"]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_38 = ["checked"]
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_41 = ["checked"]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 0,
  class: "tw-whitespace-nowrap tw-px-2 tw-pr-0 -tw-mr-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer"
}
const _hoisted_45 = ["checked", "onClick"]
const _hoisted_46 = { class: "tw-flex tw-items-center" }
const _hoisted_47 = ["title"]
const _hoisted_48 = {
  key: 1,
  class: "tw-ml-2"
}
const _hoisted_49 = ["content"]
const _hoisted_50 = ["src"]
const _hoisted_51 = ["content"]
const _hoisted_52 = ["src"]
const _hoisted_53 = ["aria-label", "onClick"]
const _hoisted_54 = {
  key: 0,
  class: "tw-absolute tw--right-1.5 tw--top-1.5 tw-inline-flex tw-h-5 tw-min-w-[1.25rem] tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-emerald-600 tw-bg-emerald-600 tw-px-1 tw-text-[10px] tw-font-bold tw-text-white"
}
const _hoisted_55 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-2" }
const _hoisted_56 = { class: "tw-text-sm tw-font-semibold tw-text-slate-900 tw-whitespace-nowrap" }
const _hoisted_57 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-2" }
const _hoisted_58 = { class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-amber-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-amber-800 tw-whitespace-nowrap" }
const _hoisted_59 = {
  key: 0,
  class: "tw-truncate"
}
const _hoisted_60 = {
  key: 1,
  class: "tw-text-slate-500"
}
const _hoisted_61 = ["title"]
const _hoisted_62 = {
  key: 0,
  class: "tw-text-sm tw-text-rose-800"
}
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_65 = {
  key: 0,
  class: "tw-inline-flex",
  style: {}
}
const _hoisted_66 = {
  key: 1,
  class: "tw-absolute tw-right-1 tw-top-3"
}
const _hoisted_67 = {
  key: 2,
  class: "tw-absolute tw-right-1 tw-top-7"
}
const _hoisted_68 = { class: "tw-whitespace-nowrap" }
const _hoisted_69 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_70 = { class: "tw-whitespace-nowrap" }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = {
  key: 1,
  class: "tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center",
  "aria-label": "Updating"
}
const _hoisted_73 = {
  key: 0,
  class: "tw-mr-2 tw-inline-flex tw-items-center tw-rounded-full tw-bg-indigo-600 tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-white"
}
const _hoisted_74 = {
  key: 1,
  class: "tw-mr-2 tw-inline-flex tw-items-center tw-rounded-full tw-bg-amber-600 tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-white"
}
const _hoisted_75 = { class: "tw-flex tw-h-full tw-min-h-0 tw-flex-col tw-gap-3" }
const _hoisted_76 = { class: "tw-shrink-0" }
const _hoisted_77 = ["checked"]
const _hoisted_78 = {
  class: "tw-min-h-0 tw-flex-1 tw-overflow-auto",
  style: {"max-height":"300px"}
}
const _hoisted_79 = { key: 0 }
const _hoisted_80 = {
  key: 1,
  ref: "exportReportElementRef"
}
const _hoisted_81 = { class: "tw-flex tw-gap-1 tw-my-1" }
const _hoisted_82 = {
  key: 0,
  style: {"white-space":"pre"}
}
const _hoisted_83 = ["innerHTML"]
const _hoisted_84 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_YardStatusLabel = _resolveComponent("YardStatusLabel")!
  const _component_Modal = _resolveComponent("Modal")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", null, [
          (_ctx.isExportSelectionMode)
            ? (_openBlock(), _createElementBlock("th", _hoisted_4, [
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "tw-inline-flex tw-pointer-events-auto",
                  checked: _ctx.selectionApi?.allSelected,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectionApi?.toggleAll()), ["stop"]))
                }, null, 8, _hoisted_5),
                _cache[34] || (_cache[34] = _createTextVNode("   ", -1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("th", {
            class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer tw-relative",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateSortBy('container')))
          }, [
            _createElementVNode("span", {
              class: "tw-h-[22px] tw-w-[20px] tw-cursor-pointer",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.updateSortBy('id')), ["prevent","stop"]))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.sortBy === 'id' ? (_ctx.sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down',
                class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-transition-transform", _ctx.sortBy === 'id' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'])
              }, null, 8, ["icon", "class"]),
              _createVNode(_component_font_awesome_icon, {
                icon: "clock",
                class: "tw-h-[10px] tw-w-[10px] tw-z-10 tw-text-slate-400"
              })
            ]),
            _createElementVNode("span", _hoisted_6, [
              (_ctx.isExportSelectionMode)
                ? (_openBlock(), _createElementBlock("label", {
                    key: 0,
                    class: "tw-cursor-pointer",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggleExportColumn('container')), ["stop","prevent"]))
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "tw-inline-flex tw-pointer-events-auto",
                      checked: _ctx.isExportColumnSelected('container')
                    }, null, 8, _hoisted_7),
                    _cache[35] || (_cache[35] = _createTextVNode(" Container ", -1))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "Container")),
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.sortBy === 'container' ? (_ctx.sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down',
                class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-transition-transform", _ctx.sortBy === 'container' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'])
              }, null, 8, ["icon", "class"])
            ])
          ]),
          _createElementVNode("th", _hoisted_9, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'sticky-note'],
              class: "tw-h-3.5 tw-w-3.5 tw-text-slate-400",
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("th", {
            class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateSortBy('bl')))
          }, [
            _createElementVNode("span", _hoisted_10, [
              (_ctx.isExportSelectionMode)
                ? (_openBlock(), _createElementBlock("label", {
                    key: 0,
                    class: "tw-cursor-pointer",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.toggleExportColumn('bl')), ["stop","prevent"]))
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "tw-inline-flex tw-pointer-events-auto",
                      checked: _ctx.isExportColumnSelected('bl')
                    }, null, 8, _hoisted_11),
                    _cache[36] || (_cache[36] = _createTextVNode(" B/L ", -1))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, "B/L")),
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.sortBy === 'bl' ? (_ctx.sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down',
                class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-transition-transform", _ctx.sortBy === 'bl' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'])
              }, null, 8, ["icon", "class"])
            ])
          ]),
          (_ctx.typeOfAppointmentsShowing === 'terminal')
            ? (_openBlock(), _createElementBlock("th", {
                key: 1,
                class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateSortBy('terminalAppt')))
              }, [
                _createElementVNode("span", _hoisted_13, [
                  (_ctx.isExportSelectionMode)
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 0,
                        class: "tw-cursor-pointer",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.toggleExportColumn('terminalAppt')), ["stop","prevent"]))
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "tw-inline-flex tw-pointer-events-auto",
                          checked: _ctx.isExportColumnSelected('terminalAppt')
                        }, null, 8, _hoisted_14),
                        _cache[37] || (_cache[37] = _createTextVNode(" Terminal Appointment ", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_15, "Terminal Appointment")),
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.sortBy === 'terminalAppt' ? (_ctx.sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down',
                    class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-transition-transform", _ctx.sortBy === 'terminalAppt' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'])
                  }, null, 8, ["icon", "class"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.typeOfAppointmentsShowing === 'delivery')
            ? (_openBlock(), _createElementBlock("th", {
                key: 2,
                class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateSortBy('deliveryAppt')))
              }, [
                _createElementVNode("span", _hoisted_16, [
                  (_ctx.isExportSelectionMode)
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 0,
                        class: "tw-cursor-pointer",
                        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.toggleExportColumn('deliveryAppt')), ["stop","prevent"]))
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "tw-inline-flex tw-pointer-events-auto",
                          checked: _ctx.isExportColumnSelected('deliveryAppt')
                        }, null, 8, _hoisted_17),
                        _cache[38] || (_cache[38] = _createTextVNode(" Delivery Appointment ", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_18, "Delivery Appointment")),
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.sortBy === 'deliveryAppt' ? (_ctx.sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down',
                    class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-transition-transform", _ctx.sortBy === 'deliveryAppt' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'])
                  }, null, 8, ["icon", "class"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("th", {
            class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateSortBy('eta')))
          }, [
            _createElementVNode("span", _hoisted_19, [
              (_ctx.isExportSelectionMode)
                ? (_openBlock(), _createElementBlock("label", {
                    key: 0,
                    class: "tw-cursor-pointer",
                    onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.toggleExportColumn('eta')), ["stop","prevent"]))
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "tw-inline-flex tw-pointer-events-auto",
                      checked: _ctx.isExportColumnSelected('eta')
                    }, null, 8, _hoisted_20),
                    _cache[39] || (_cache[39] = _createTextVNode(" ETA/LFD ", -1))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_21, "ETA/LFD")),
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.sortBy === 'eta' ? (_ctx.sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down',
                class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-transition-transform", _ctx.sortBy === 'eta' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'])
              }, null, 8, ["icon", "class"])
            ])
          ]),
          (!_ctx.typeOfAppointmentsShowing)
            ? (_openBlock(), _createElementBlock("th", {
                key: 3,
                class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateSortBy('vessel')))
              }, [
                _createElementVNode("span", _hoisted_22, [
                  (_ctx.isExportSelectionMode)
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 0,
                        class: "tw-cursor-pointer",
                        onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.toggleExportColumn('vessel')), ["stop","prevent"]))
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "tw-inline-flex tw-pointer-events-auto",
                          checked: _ctx.isExportColumnSelected('vessel')
                        }, null, 8, _hoisted_23),
                        _cache[40] || (_cache[40] = _createTextVNode(" Vessel Name ", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_24, "Vessel Name")),
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.sortBy === 'vessel' ? (_ctx.sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down',
                    class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-transition-transform", _ctx.sortBy === 'vessel' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'])
                  }, null, 8, ["icon", "class"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("th", {
            class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer",
            onClick: _cache[15] || (_cache[15] = ($event: any) => ( _ctx.updateSortBy('yard')))
          }, [
            _createElementVNode("span", _hoisted_25, [
              (_ctx.isExportSelectionMode)
                ? (_openBlock(), _createElementBlock("label", {
                    key: 0,
                    class: "tw-cursor-pointer",
                    onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.toggleExportColumn('yardStatus')), ["stop","prevent"]))
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "tw-inline-flex tw-pointer-events-auto",
                      checked: _ctx.isExportColumnSelected('yardStatus')
                    }, null, 8, _hoisted_26),
                    _cache[41] || (_cache[41] = _createTextVNode(" Yard Status ", -1))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_27, "Yard Status")),
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.sortBy === 'yard' ? (_ctx.sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down',
                class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-transition-transform", _ctx.sortBy === 'yard' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'])
              }, null, 8, ["icon", "class"])
            ])
          ]),
          _createElementVNode("th", {
            class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.updateSortBy('terminal')))
          }, [
            _createElementVNode("span", _hoisted_28, [
              (_ctx.isExportSelectionMode)
                ? (_openBlock(), _createElementBlock("label", {
                    key: 0,
                    class: "tw-cursor-pointer",
                    onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.toggleExportColumn('terminal')), ["stop","prevent"]))
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "tw-inline-flex tw-pointer-events-auto",
                      checked: _ctx.isExportColumnSelected('terminal')
                    }, null, 8, _hoisted_29),
                    _cache[42] || (_cache[42] = _createTextVNode(" Terminal ", -1))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_30, "Terminal")),
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.sortBy === 'terminal' ? (_ctx.sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down',
                class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-transition-transform", _ctx.sortBy === 'terminal' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'])
              }, null, 8, ["icon", "class"])
            ])
          ]),
          _createElementVNode("th", _hoisted_31, [
            (_ctx.isExportSelectionMode)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  class: "tw-cursor-pointer",
                  onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.toggleExportColumn('sizeType')), ["stop","prevent"]))
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "tw-inline-flex tw-pointer-events-auto",
                    checked: _ctx.isExportColumnSelected('sizeType')
                  }, null, 8, _hoisted_32),
                  _cache[43] || (_cache[43] = _createTextVNode(" Type ", -1))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_33, "Type"))
          ]),
          (!_ctx.isHideCustomerInfo)
            ? (_openBlock(), _createElementBlock("th", {
                key: 4,
                class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.updateSortBy('customer')))
              }, [
                _createElementVNode("span", _hoisted_34, [
                  (_ctx.isExportSelectionMode)
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 0,
                        class: "tw-cursor-pointer",
                        onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.toggleExportColumn('customer')), ["stop","prevent"]))
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "tw-inline-flex tw-pointer-events-auto",
                          checked: _ctx.isExportColumnSelected('customer')
                        }, null, 8, _hoisted_35),
                        _cache[44] || (_cache[44] = _createTextVNode(" Customer ", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_36, "Customer")),
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.sortBy === 'customer' ? (_ctx.sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down',
                    class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-transition-transform", _ctx.sortBy === 'customer' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'])
                  }, null, 8, ["icon", "class"])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.typeOfAppointmentsShowing)
            ? (_openBlock(), _createElementBlock("th", {
                key: 5,
                class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.updateSortBy('lastTerminalScrapeUpdate')))
              }, [
                _createElementVNode("span", _hoisted_37, [
                  (_ctx.isExportSelectionMode)
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 0,
                        class: "tw-cursor-pointer",
                        onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.toggleExportColumn('lastTerminalScrapeUpdate')), ["stop","prevent"]))
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "tw-inline-flex tw-pointer-events-auto",
                          checked: _ctx.isExportColumnSelected('lastTerminalScrapeUpdate')
                        }, null, 8, _hoisted_38),
                        _cache[45] || (_cache[45] = _createTextVNode(" Scrape Update ", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_39, "Scrape Update")),
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.sortBy === 'lastTerminalScrapeUpdate' ? (_ctx.sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down',
                    class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-transition-transform", _ctx.sortBy === 'lastTerminalScrapeUpdate' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'])
                  }, null, 8, ["icon", "class"])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.typeOfAppointmentsShowing)
            ? (_openBlock(), _createElementBlock("th", {
                key: 6,
                class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-cursor-pointer",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.updateSortBy('lastTerminalScrapeFetch')))
              }, [
                _createElementVNode("span", _hoisted_40, [
                  (_ctx.isExportSelectionMode)
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 0,
                        class: "tw-cursor-pointer",
                        onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.toggleExportColumn('lastTerminalScrapeFetch')), ["stop","prevent"]))
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "tw-inline-flex tw-pointer-events-auto",
                          checked: _ctx.isExportColumnSelected('lastTerminalScrapeFetch')
                        }, null, 8, _hoisted_41),
                        _cache[46] || (_cache[46] = _createTextVNode(" Last Scrape ", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_42, "Last Scrape")),
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.sortBy === 'lastTerminalScrapeFetch' ? (_ctx.sortOrder === 'ASC' ? 'circle-chevron-up' : 'circle-chevron-down') : 'chevron-down',
                    class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-transition-transform", _ctx.sortBy === 'lastTerminalScrapeFetch' ? 'tw-text-slate-900 tw-h-5 tw-w-5' : 'tw-text-slate-400'])
                  }, null, 8, ["icon", "class"])
                ])
              ]))
            : _createCommentVNode("", true),
          _cache[47] || (_cache[47] = _createElementVNode("th", null, null, -1))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredContainers, (container, containerIndex) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: container.id,
            class: _normalizeClass(["table-row", [
          _ctx.getIsLastOpenedListItem(_ctx.lastOpenedContainerId, container.id)
            ? 'tw-bg-amber-100/70'
            : (containerIndex % 2 === 0 ? 'tw-bg-white/25' : 'tw-bg-sky-50/60'),
          'hover:tw-bg-slate-900/5',
        ]]),
            onClick: ($event: any) => (_ctx.isExportSelectionMode ? _ctx.toggleExportContainer(container.id) : _ctx.selectContainer(container.id))
          }, [
            (_ctx.isExportSelectionMode)
              ? (_openBlock(), _createElementBlock("td", _hoisted_44, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "tw-inline-flex tw-pointer-events-auto",
                    checked: _ctx.isExportContainerIdSelected(container.id),
                    onClick: _withModifiers(($event: any) => (_ctx.toggleExportContainer(container.id)), ["stop"])
                  }, null, 8, _hoisted_45),
                  _cache[48] || (_cache[48] = _createTextVNode("   ", -1))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("td", {
              class: _normalizeClass(["tw-px-4 tw-py-4 tw-align-top", [_ctx.isExportColumnSelectedForContainerId('container', container.id) ? 'tw-bg-emerald-100' : '']])
            }, [
              _createElementVNode("div", _hoisted_46, [
                _createVNode(_component_CopyButton, {
                  value: container.containerId,
                  mode: "wrap-content",
                  "icon-position": "left",
                  title: "Copy container ID",
                  "aria-label": "Copy container ID to clipboard",
                  class: "tw-font-semibold tw-text-slate-900 tw-font-bold"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(container.containerId), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]),
                (container.isCancelled)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "tw-ml-2 tw-inline-flex tw-items-center tw-rounded-md tw-bg-rose-50 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-rose-800 tw-ring-1 tw-ring-inset tw-ring-rose-600/20",
                      title: container.cancelledReason || 'Cancelled on order'
                    }, " Cancelled ", 8, _hoisted_47))
                  : _createCommentVNode("", true),
                (container && container.order)
                  ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_48, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "tag",
                        class: _normalizeClass(["tw-h-3.5 tw-w-3.5", container.order && container.order.status === 'In Progress' ? 'tw-text-emerald-600' : 'tw-text-slate-400'])
                      }, null, 8, ["class"])
                    ])), [
                      [_directive_tippy, { content: `Container part of Order ${container.order.id}`, placement: 'top-end' }]
                    ])
                  : _createCommentVNode("", true),
                _withDirectives((_openBlock(), _createElementBlock("span", {
                  content: `Terminal Appointment: ${_ctx.formatAppointmentDatetime(
                container.terminalAppointmentDate,
                container.terminalAppointmentHasTime,
              )}`
                }, [
                  (container.terminalAppointmentDate)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.ShipIcon,
                        alt: "Terminal Appointment",
                        class: "tw-m-1 tw-h-5 tw-w-5"
                      }, null, 8, _hoisted_50))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_49)), [
                  [_directive_tippy, { placement: 'bottom' }]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("span", {
                  content: `Delivery Appointment: ${_ctx.formatAppointmentDatetime(
                container.deliveryAppointmentDate,
                container.deliveryAppointmentHasTime,
              )}`
                }, [
                  (container.deliveryAppointmentDate)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.DeliveryIcon,
                        alt: "Terminal Appointment",
                        class: "tw-m-1 tw-h-5 tw-w-5 tw-font-slate-400"
                      }, null, 8, _hoisted_52))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_51)), [
                  [_directive_tippy, { placement: 'bottom' }]
                ])
              ])
            ], 2),
            _createElementVNode("td", {
              class: "notes-cell tw-w-14 tw-px-2 tw-py-4 tw-align-middle tw-text-center",
              onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"]))
            }, [
              _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                class: _normalizeClass(["tw-relative tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-border tw-p-1.5 tw-text-xs tw-font-semibold tw-transition", _ctx.containerNotesCount(container) > 0
                ? 'tw-border-emerald-300 tw-bg-emerald-50 tw-text-emerald-700 hover:tw-bg-emerald-100'
                : 'tw-border-slate-300 tw-bg-slate-100 tw-text-slate-900 hover:tw-bg-slate-200']),
                "aria-label": `Container notes, ${_ctx.containerNotesCount(container)}`,
                onClick: _withModifiers(($event: any) => (_ctx.openContainerNotes(container)), ["stop"])
              }, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'sticky-note'] }),
                (_ctx.containerNotesCount(container) > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.containerNotesCount(container)), 1))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_53)), [
                [_directive_tippy, _ctx.containerNotesCount(container) > 0
                ? `View ${_ctx.containerNotesCount(container)} note${_ctx.containerNotesCount(container) > 1 ? 's' : ''}`
                : 'Add container notes']
              ])
            ]),
            (container.billOfLading)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 1,
                  class: _normalizeClass(["tw-px-4 tw-py-4 tw-align-top tw-text-slate-700", [_ctx.isExportColumnSelectedForContainerId('bl', container.id) ? 'tw-bg-emerald-100' : '']])
                }, [
                  _createVNode(_component_CopyButton, {
                    value: container.billOfLading.billOfLadingNumber,
                    mode: "wrap-content",
                    title: "Copy B/L number",
                    "aria-label": "Copy B/L number to clipboard"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(container.billOfLading.billOfLadingNumber), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"])
                ], 2))
              : (_openBlock(), _createElementBlock("td", {
                  key: 2,
                  class: _normalizeClass(["tw-px-4 tw-py-4 tw-align-top tw-text-slate-500", [_ctx.isExportColumnSelectedForContainerId('bl', container.id) ? 'tw-bg-emerald-100' : '']])
                }, "N/A", 2)),
            (_ctx.typeOfAppointmentsShowing === 'delivery')
              ? (_openBlock(), _createElementBlock("td", {
                  key: 3,
                  class: _normalizeClass(["tw-px-4 tw-py-4 tw-align-top tw-text-left tw-text-slate-700", [_ctx.isExportColumnSelectedForContainerId('deliveryAppt', container.id) ? 'tw-bg-emerald-100' : '']])
                }, _toDisplayString(_ctx.formatAppointmentDatetime(container.deliveryAppointmentDate, container.deliveryAppointmentHasTime)), 3))
              : _createCommentVNode("", true),
            (_ctx.typeOfAppointmentsShowing === 'terminal')
              ? (_openBlock(), _createElementBlock("td", {
                  key: 4,
                  class: _normalizeClass(["tw-px-4 tw-py-4 tw-align-top tw-text-left tw-text-slate-700", [_ctx.isExportColumnSelectedForContainerId('terminalAppt', container.id) ? 'tw-bg-emerald-100' : '']])
                }, _toDisplayString(_ctx.formatAppointmentDatetime(container.terminalAppointmentDate, container.terminalAppointmentHasTime)), 3))
              : _createCommentVNode("", true),
            (_ctx.getIsEtaShownForYardStatus(container.yardStatus))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 5,
                  class: _normalizeClass(["tw-px-4 tw-py-4 tw-align-top", [_ctx.isExportColumnSelectedForContainerId('eta', container.id) ? 'tw-bg-emerald-100' : '']])
                }, [
                  _createElementVNode("div", _hoisted_55, [
                    _cache[49] || (_cache[49] = _createElementVNode("span", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, "ETA", -1)),
                    _createElementVNode("span", _hoisted_56, _toDisplayString(container.eta), 1)
                  ])
                ], 2))
              : (container.lfd && container.lfd.length > 2)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 6,
                    class: _normalizeClass(["tw-px-4 tw-py-4 tw-align-top", [_ctx.isExportColumnSelectedForContainerId('eta', container.id) ? 'tw-bg-emerald-100' : '']])
                  }, [
                    _createElementVNode("div", _hoisted_57, [
                      _cache[50] || (_cache[50] = _createElementVNode("span", { class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-amber-100 tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-amber-800" }, "LFD", -1)),
                      _createElementVNode("span", _hoisted_58, _toDisplayString(container.lfd), 1)
                    ])
                  ], 2))
                : (_openBlock(), _createElementBlock("td", {
                    key: 7,
                    class: _normalizeClass(["tw-px-4 tw-py-4 tw-align-top", [_ctx.isExportColumnSelectedForContainerId('eta', container.id) ? 'tw-bg-emerald-100' : '']])
                  }, [...(_cache[51] || (_cache[51] = [
                    _createElementVNode("span", { class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-amber-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-amber-800" }, "No LFD", -1)
                  ]))], 2)),
            (!_ctx.typeOfAppointmentsShowing)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 8,
                  class: _normalizeClass(["tw-px-4 tw-py-4 tw-align-top tw-text-slate-700", [_ctx.isExportColumnSelectedForContainerId('vessel', container.id) ? 'tw-bg-emerald-100' : '']])
                }, [
                  (container.vessel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(container.vessel.name), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_60, "Vessel Not Available"))
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("td", {
              class: _normalizeClass(["tw-px-4 tw-py-4 tw-align-top", [_ctx.isExportColumnSelectedForContainerId('yardStatus', container.id) ? 'tw-bg-emerald-100' : '']]),
              title: container.isCancelled
            ? (container.cancelledReason || 'Cancelled on order')
            : (container.yardStatusDescription.split('\n')[1] &&
              container.yardStatusDescription.split('\n')[1] != '\xa0'
              ? `${container.yardStatusDescription.split('\n')[1]}`
              : '')
            
            }, [
              (container.isCancelled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                    _cache[52] || (_cache[52] = _createTextVNode(" Cancelled ", -1)),
                    (container.cancelledReason)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_63, " — " + _toDisplayString(container.cancelledReason), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock(_component_YardStatusLabel, {
                    key: 1,
                    container: container,
                    enableStale: false
                  }, null, 8, ["container"]))
            ], 10, _hoisted_61),
            (container.terminal.includes('Expected'))
              ? (_openBlock(), _createElementBlock("td", {
                  key: 9,
                  class: _normalizeClass(["tw-px-4 tw-py-4 tw-align-top tw-text-slate-700", [_ctx.isExportColumnSelectedForContainerId('terminal', container.id) ? 'tw-bg-emerald-100' : _ctx.terminalCellClass(container.terminal)]]),
                  title: "Container not yet found, system will try this terminal at next update"
                }, [
                  _createElementVNode("div", _hoisted_64, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "triangle-exclamation",
                      class: "tw-h-4 tw-w-4 tw-text-amber-600"
                    }),
                    _createElementVNode("span", null, _toDisplayString(container.terminal.split('(')[0]), 1)
                  ])
                ], 2))
              : (_openBlock(), _createElementBlock("td", {
                  key: 10,
                  class: _normalizeClass(["tw-px-4 tw-py-4 tw-align-top tw-text-slate-700", [_ctx.isExportColumnSelectedForContainerId('terminal', container.id) ? 'tw-bg-emerald-100' : _ctx.terminalCellClass(container.terminal)]])
                }, _toDisplayString(container.terminal), 3)),
            _createElementVNode("td", {
              class: _normalizeClass(["tw-relative tw-pl-3 tw-pr-0 tw-py-4 tw-align-top tw-text-slate-700", [_ctx.isExportColumnSelectedForContainerId('sizeType', container.id) ? 'tw-bg-emerald-100' : '']])
            }, [
              _createTextVNode(_toDisplayString(container.sizeType) + " ", 1),
              (_ctx.getIsReeferSizeType(container.sizeType))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (!container.isGensetRequired && !_ctx.getHasGensetTemperatureOrVents(container))
                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_65, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "snowflake",
                            class: "tw-h-3 tw-w-3 tw-text-sky-500"
                          })
                        ])), [
                          [_directive_tippy, { content: 'Reefer', placement: 'top' }]
                        ])
                      : _createCommentVNode("", true),
                    (container.isGensetRequired)
                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_66, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "bolt-lightning",
                            class: _normalizeClass(["tw-h-3 tw-w-3", container.isGensetApprovedByShipline === true ? 'tw-text-emerald-400' : 'tw-text-slate-500'])
                          }, null, 8, ["class"])
                        ])), [
                          [_directive_tippy, { content: container.isGensetApprovedByShipline === true ? 'Genset needed, approved' : 'Genset needed, NOT approved yet', placement: 'top' }]
                        ])
                      : _createCommentVNode("", true),
                    (_ctx.getHasGensetTemperatureOrVents(container))
                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_67, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "temperature-high",
                            class: "tw-h-3 tw-w-3 tw-text-slate-500"
                          })
                        ])), [
                          [_directive_tippy, { content: _ctx.getGensetTemperatureAndVentsTooltip(container), placement: 'bottom' }]
                        ])
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 2),
            (!_ctx.isHideCustomerInfo)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 11,
                  class: _normalizeClass(["tw-px-4 tw-py-4 tw-align-top", [container.customer ? 'tw-text-slate-700' : 'tw-text-slate-500', _ctx.isExportColumnSelectedForContainerId('customer', container.id) ? 'tw-bg-emerald-100' : '']])
                }, _toDisplayString(container.customer ? (
                container.customer.displayName
                  ? container.customer.displayName
                  : container.customer.name
              ) : 'N/A'), 3))
              : _createCommentVNode("", true),
            (!_ctx.typeOfAppointmentsShowing)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 12,
                  class: _normalizeClass(["tw-px-4 tw-py-4 tw-align-top tw-text-slate-700", [_ctx.isExportColumnSelectedForContainerId('lastTerminalScrapeUpdate', container.id) ? 'tw-bg-emerald-100' : '']])
                }, [
                  _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.formatScraperUpdate(container.lastScraperUpdate)), 1)
                ], 2))
              : _createCommentVNode("", true),
            (!_ctx.typeOfAppointmentsShowing)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 13,
                  class: _normalizeClass(["tw-px-4 tw-py-4 tw-align-top tw-text-slate-700", [_ctx.isExportColumnSelectedForContainerId('lastTerminalScrapeFetch', container.id) ? 'tw-bg-emerald-100' : '']])
                }, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.formatScraperUpdate(container.lastScraperFetch)), 1),
                    (!_ctx.loading.includes(container.id))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: [
                            ($event: any) => (_ctx.rescrapeContainerFromTerminal(container.id)),
                            _cache[26] || (_cache[26] = _withModifiers(() => {}, ["stop"]))
                          ],
                          type: "button",
                          title: "Update Container",
                          class: "tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-text-slate-600 hover:tw-bg-white"
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "rotate-right",
                            class: "tw-h-3.5 tw-w-3.5"
                          })
                        ], 8, _hoisted_71))
                      : (_openBlock(), _createElementBlock("span", _hoisted_72, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "circle-notch",
                            spin: "",
                            class: "tw-h-4 tw-w-4 tw-text-slate-500"
                          })
                        ]))
                  ]),
                  (_ctx.getIsContainerAddedSincePageLoad(container.containerId))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_73, "New"))
                    : _createCommentVNode("", true),
                  (_ctx.getIsContainerChangedSincePageLoad(container.containerId))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_74, "Changed"))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ], 10, _hoisted_43))
        }), 128))
      ])
    ]),
    _createVNode(_component_Modal, {
      isOpen: _ctx.isExportSelectionModalOpen,
      "onUpdate:isOpen": _cache[33] || (_cache[33] = ($event: any) => (_ctx.$emit('update:isExportSelectionModalOpen', $event))),
      modalId: "tracking-export-selection-modal",
      maxWidth: "7xl",
      ariaLabel: "Container details"
    }, {
      title: _withCtx(() => [...(_cache[53] || (_cache[53] = [
        _createTextVNode(" Export Selection ", -1)
      ]))]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("button", {
              class: _normalizeClass(["tw-gap-2 tw-px-2 tw-py-2 tw-backdrop-blur tw-border tw-rounded-xl tw-shadow-sm tw-transition-all tw-text-sm tw-font-medium", [_ctx.exportSelectionFormat === 'csv' ? 'tw-bg-slate-600 tw-text-white' : 'tw-bg-slate-200 tw-text-black']]),
              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.$emit('update:exportSelectionFormat', 'csv')))
            }, "CSV", 2),
            _cache[55] || (_cache[55] = _createTextVNode("   ", -1)),
            _createElementVNode("button", {
              class: _normalizeClass(["tw-gap-2 tw-px-2 tw-py-2 tw-backdrop-blur tw-border tw-rounded-xl tw-shadow-sm tw-transition-all tw-text-sm tw-font-medium", [_ctx.exportSelectionFormat === 'text' ? 'tw-bg-slate-600 tw-text-white' : 'tw-bg-slate-200 tw-text-black']]),
              onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.$emit('update:exportSelectionFormat', 'text')))
            }, "Text", 2),
            _cache[56] || (_cache[56] = _createTextVNode("   ", -1)),
            _createElementVNode("button", {
              class: _normalizeClass(["tw-px-2 tw-py-2 tw-backdrop-blur tw-border tw-rounded-xl tw-shadow-sm tw-transition-all tw-text-sm tw-font-medium", [_ctx.exportSelectionFormat === 'html' ? 'tw-bg-slate-600 tw-text-white' : 'tw-bg-slate-200 tw-text-black']]),
              onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.$emit('update:exportSelectionFormat', 'html')))
            }, "HTML", 2),
            _cache[57] || (_cache[57] = _createTextVNode("   ", -1)),
            _createElementVNode("label", null, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: _ctx.isExportReportShowHeader,
                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.isExportReportShowHeader = !_ctx.isExportReportShowHeader))
              }, null, 8, _hoisted_77),
              _cache[54] || (_cache[54] = _createTextVNode(" Show header", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_78, [
            (!_ctx.selectionApi.count)
              ? (_openBlock(), _createElementBlock("div", _hoisted_79, "No rows selected"))
              : (_openBlock(), _createElementBlock("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("button", {
                      class: "tw-bg-slate-100 tw-text-black tw-px-4 tw-py-2 tw-rounded tw-rounded-xl",
                      onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.copyExportReport()))
                    }, [
                      _cache[58] || (_cache[58] = _createTextVNode(" Copy ", -1)),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "copy",
                        class: "tw-h-5 tw-w-5 tw-z-10 tw-text-slate-800"
                      })
                    ]),
                    _cache[60] || (_cache[60] = _createTextVNode("   ", -1)),
                    _createElementVNode("button", {
                      class: "tw-bg-slate-100 tw-text-black tw-px-4 tw-py-2 tw-rounded tw-rounded-xl",
                      onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.downloadExportReport()))
                    }, [
                      _cache[59] || (_cache[59] = _createTextVNode(" Download ", -1)),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "download",
                        class: "tw-h-5 tw-w-5 tw-z-10 tw-text-slate-800"
                      })
                    ])
                  ]),
                  (_ctx.exportSelectionFormat === 'csv' || _ctx.exportSelectionFormat === 'text')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, _toDisplayString(_ctx.exportReportString), 1))
                    : (_ctx.exportSelectionFormat === 'html')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          innerHTML: _ctx.exportReportString
                        }, null, 8, _hoisted_83))
                      : (_openBlock(), _createElementBlock("div", _hoisted_84, "No export format selected"))
                ], 512))
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen"])
  ]))
}